// eslint-disable-next-line import/no-extraneous-dependencies
import gql from 'graphql-tag'

export const getPendingCheckoutsCount = gql`
  query getPendingCheckoutCount {
    pendingCheckoutsCount
  }
`
